export const CLOSE = 'close'
export const LOGIN = 'login'
export const CREATE_ACCOUNT = 'create-account'
